// extracted by mini-css-extract-plugin
export default {"pageWrap":"Da-z","fullWidth":"Ea-z","heading":"Fa-z","fullBleed":"Ga-z","hidden":"Ha-z"};